import type { FunctionComponent } from 'react';
import { LiquidityPlanner } from '../../liquidity-planner';
import { useLayout } from '../contexts/layout-context';
import { useWealthPlanningNavigate } from '../hooks/useWealthPlanningNavigate';

export const LiquidityPlannerScreen: FunctionComponent = () => {
    const { totalNavbarHeight } = useLayout();
    const { partnerUuid } = useWealthPlanningNavigate();

    return (
        <div style={{ width: '100vw', height: `calc(100vh - ${totalNavbarHeight}px)` }}>
            <LiquidityPlanner partnerUuid={partnerUuid} />
        </div>
    );
};
